/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Gérant (juridique) déclaré à la création d'une personne morale : le fondateur, dont le mobile reçoit les codes de signature des mandats de prélèvement. Civilité et mobile requis.
 * @export
 * @interface GerantCabinetDto
 */
export interface GerantCabinetDto {
    /**
     * 
     * @type {string}
     * @memberof GerantCabinetDto
     */
    civiliteId: string;
    /**
     * Mobile français (06 / 07).
     * @type {string}
     * @memberof GerantCabinetDto
     */
    phone: string;
}

/**
 * Check if a given object implements the GerantCabinetDto interface.
 */
export function instanceOfGerantCabinetDto(value: object): value is GerantCabinetDto {
    if (!('civiliteId' in value) || value['civiliteId'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function GerantCabinetDtoFromJSON(json: any): GerantCabinetDto {
    return GerantCabinetDtoFromJSONTyped(json, false);
}

export function GerantCabinetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GerantCabinetDto {
    if (json == null) {
        return json;
    }
    return {
        
        'civiliteId': json['civiliteId'],
        'phone': json['phone'],
    };
}

export function GerantCabinetDtoToJSON(json: any): GerantCabinetDto {
    return GerantCabinetDtoToJSONTyped(json, false);
}

export function GerantCabinetDtoToJSONTyped(value?: GerantCabinetDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'civiliteId': value['civiliteId'],
        'phone': value['phone'],
    };
}

